import { DateTime } from "luxon";
var UNITS;
(function (UNITS) {
    UNITS["DAY"] = "day";
    UNITS["MONTH"] = "month";
    UNITS["YEAR"] = "year";
})(UNITS || (UNITS = {}));
const UNIT_VALUES = Object.values(UNITS);
const SAMPLE = {
    [UNITS.DAY]: 1,
    [UNITS.MONTH]: 2,
    [UNITS.YEAR]: 3333,
};
const TOKENS = {
    [UNITS.DAY]: "d",
    [UNITS.MONTH]: "M",
    [UNITS.YEAR]: "y",
};
const DEFAULT_SEPARATOR = "/";
const DEFAULT_FORMATS = [
    "ddMMyyyy",
    "MMddyyyy",
];
function detectLocaleDateFormat() {
    const localeDate = DateTime
        .fromObject({ day: SAMPLE[UNITS.DAY], month: SAMPLE[UNITS.MONTH], year: SAMPLE[UNITS.YEAR] })
        .toLocaleString();
    let buffer = "";
    let separator = DEFAULT_SEPARATOR;
    let format = [];
    let maskFormat = [];
    let placeholderFormat = [];
    for (const c of localeDate) {
        buffer += c;
        const parsed = parseInt(buffer);
        if (Number.isNaN(parsed)) {
            separator = c;
            buffer = "";
            continue;
        }
        for (const u of UNIT_VALUES) {
            if (parsed == SAMPLE[u]) {
                const token = TOKENS[u];
                format.push(Array(buffer.length).fill(token).join(""));
                maskFormat.push(Array(buffer.length).fill("#").join(""));
                placeholderFormat.push(Array(buffer.length).fill("_").join(""));
                buffer = "";
            }
        }
    }
    return {
        separator,
        parseFormat: format.join(""),
        displayFormat: format.join(separator),
        mask: maskFormat.join(separator),
        placeholder: placeholderFormat.join(separator),
    };
}
let currentFormat = detectLocaleDateFormat();
export function getLocaleDateFormat() {
    return currentFormat;
}
export function refreshLocaleDateFormat() {
    currentFormat = detectLocaleDateFormat();
    return currentFormat;
}
export function parseLocaleDate(date) {
    const localeDate = DateTime.fromFormat(date, currentFormat.displayFormat);
    if (localeDate.isValid)
        return localeDate;
    const onlyNumeric = date.replace(/[^0-9]/gi, "");
    const otherResults = DEFAULT_FORMATS
        .map(x => DateTime.fromFormat(onlyNumeric, x))
        .filter(x => x.isValid);
    return otherResults[0];
}
//# sourceMappingURL=index.js.map